import React from 'react';
import { XCircleIcon, CheckCircleIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
const ComparisonSection = () => {
  const {
    t
  } = useLanguage();
  return <section className="py-16 px-4 bg-white" data-id="element-84">
      <div className="container mx-auto max-w-5xl" data-id="element-85">
        <div className="text-center mb-12" data-id="element-86">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-primary mb-4" data-id="element-87">
            {t.comparison.headline}
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-88">
            {t.comparison.subheadline}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-89">
          {/* The "Other" Way */}
          <div className="bg-sand-50 p-8 rounded-2xl shadow-sm border border-sand-200 opacity-90 hover:opacity-100 transition-opacity" data-id="element-90">
            <div className="flex items-center gap-3 mb-6 border-b border-sand-200 pb-4" data-id="element-91">
              <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center" data-id="element-92">
                <XCircleIcon className="w-6 h-6 text-red-500" data-id="element-93" />
              </div>
              <h3 className="font-bold text-xl text-gray-800" data-id="element-94">
                {t.comparison.badTitle}
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-95">
              {t.comparison.badPoints.map((point, index) => <li key={index} className="flex items-start gap-3 text-gray-600" data-id="element-96">
                  <XCircleIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-97" />
                  <span data-id="element-98">{point}</span>
                </li>)}
            </ul>
          </div>

          {/* Pedro's Way */}
          <div className="bg-white p-8 rounded-2xl shadow-xl border-2 border-success/20 relative transform md:-translate-y-4" data-id="element-99">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-success text-white px-4 py-1 rounded-full text-sm font-bold shadow-md whitespace-nowrap" data-id="element-100">
              {t.comparison.goodBadge}
            </div>
            <div className="flex items-center gap-3 mb-6 border-b border-gray-100 pb-4" data-id="element-101">
              <div className="w-10 h-10 rounded-full bg-success/10 flex items-center justify-center" data-id="element-102">
                <CheckCircleIcon className="w-6 h-6 text-success" data-id="element-103" />
              </div>
              <h3 className="font-bold text-xl text-primary" data-id="element-104">
                {t.comparison.goodTitle}
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-105">
              {t.comparison.goodPoints.map((point, index) => <li key={index} className="flex items-start gap-3 text-gray-800 font-medium" data-id="element-106">
                  <CheckCircleIcon className="w-5 h-5 text-success flex-shrink-0 mt-0.5" data-id="element-107" />
                  <span data-id="element-108">{point}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
};
export default ComparisonSection;